import React, { useState } from "react";
import { ROUTES } from "../App";
import Lottie from "lottie-react";
import fireAnimation from "../assets/animations/fire.json";

const CommunitiesList = ({ communities, navigate }) => {
    // Track loading state for each image
    const [loadedImages, setLoadedImages] = useState({});

    const handleImageLoad = (id) => {
        setLoadedImages((prev) => ({ ...prev, [id]: true }));
    };

    return (
        <>
            {communities.length === 0 ? (
                <div className="text-center text-gray-500 dark:text-gray-400 mt-20">
                    No communities found.
                </div>
            ) : (
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-6 mt-6 md:mt-6">
                    {communities.map((community, i) => (
                        <div
                            key={community.id || i}
                            className="text-center cursor-pointer"
                            onClick={() => navigate(`${ROUTES.COMMUNITY_CHAT}/${community.id}`)}
                        >
                            <div className="relative w-20 h-20 md:w-24 md:h-24 mx-auto rounded-full ">
                                {/* 🩶 Shimmer placeholder */}
                                {!loadedImages[community.id] && (
                                    <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 rounded-full" />
                                )}

                                {/* 🖼️ Community image */}
                                <img
                                    src={community.imageUrl || "https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/group-photo.png?alt=media&token=5109cfab-8e78-43c4-9d86-0ed964c87346"}
                                    alt={community.name}
                                    className={`w-full h-full rounded-full object-cover border-2 border-gray-700 transition-opacity duration-300 ${loadedImages[community.id] ? "opacity-100" : "opacity-0"
                                        }`}
                                    onLoad={() => handleImageLoad(community.id)}
                                    onError={() => handleImageLoad(community.id)}
                                />

                                {/* 🔵 Unread indicator */}
                                {community.hasUnread && (
                                    <span className="w-5 h-5 bg-red-500 rounded-full absolute top-2 right-1 border-2 border-black"></span>
                                )}

                                {community.isActive && (
                                    <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1 bg-white rounded-full px-1.5 py-0.5 shadow">
                                        <Lottie
                                            animationData={fireAnimation}
                                            loop
                                            autoplay
                                            className="w-4 h-4"
                                        />
                                        {community.streakDays > 0 && (
                                            <span className="text-[10px] font-bold text-black">
                                                {community.streakDays}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 🧾 Name */}
                            <p className="text-center mt-2 text-sm truncate">{community.name}</p>
                        </div>
                    ))}
                </div>
            )}

        </>

    );
};

export default React.memo(CommunitiesList);
